document.addEventListener('DOMContentLoaded', () => {
  const btn = document.querySelector('.mobile-menu-btn');
  const menu = document.getElementById('MobileMenu');

  if (btn && menu) {
    btn.addEventListener('click', () => {
      const open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
    });
  }
document.querySelectorAll('.booking-product-form').forEach(form => {
  const hiddenId = form.querySelector('[data-booking-variant-id]');
  const serviceSelect = form.querySelector('[data-booking-service]');
  const optionsWrap = form.querySelector('.booking-options');
  const priceBox = form.querySelector('[data-booking-price] strong');
  const submit = form.querySelector('[data-booking-submit]');

  if (!hiddenId || !serviceSelect || !optionsWrap || !priceBox || !submit) return;

  const productData = {};
  form.querySelectorAll('[data-booking-product]').forEach(script => {
    try {
      productData[script.dataset.bookingProduct] = JSON.parse(script.textContent);
    } catch (e) {
  console.error('Booking product JSON error:', e, script.textContent);
}
  });

  const money = cents =>
    new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0
    }).format(cents / 100);

  const renderOptions = product => {
    optionsWrap.innerHTML = '';

    if (!product || !product.options || !product.variants) {
      priceBox.textContent = 'Unavailable';
      submit.disabled = true;
      return;
    }

    product.options.forEach((optionName, index) => {
      const label = document.createElement('label');
      label.textContent = optionName;

      const select = document.createElement('select');
      select.dataset.bookingOption = index + 1;
      select.required = true;

      const placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = 'Select';
      select.appendChild(placeholder);

      const values = [...new Set(product.variants.map(v => v.options[index]))];

      values.forEach(value => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = value;
        select.appendChild(option);
      });

      select.addEventListener('change', syncVariant);
      label.appendChild(select);
      optionsWrap.appendChild(label);
    });

    priceBox.textContent = 'Select your home size';
    hiddenId.value = '';
    submit.disabled = true;
  };

  const syncVariant = () => {
    const serviceKey = serviceSelect.value;
    const product = productData[serviceKey];
    if (!product) return;

    const selects = [...optionsWrap.querySelectorAll('[data-booking-option]')];
    const chosen = selects.map(s => s.value);

    const variant = product.variants.find(v =>
      chosen.every((value, idx) => value && v.options[idx] === value)
    );

    if (variant) {
      hiddenId.value = variant.id;
      priceBox.textContent = money(variant.price);
      submit.disabled = !variant.available;
    } else {
      hiddenId.value = '';
      priceBox.textContent = chosen.some(Boolean)
        ? 'Choose a valid combination'
        : 'Select your home size';
      submit.disabled = true;
    }
  };

  const loadService = () => {
  const serviceKey = serviceSelect.value;

  if (serviceKey === 'large' || serviceKey === 'airbnb' || serviceKey === 'commercial') {
    optionsWrap.innerHTML = '';
    hiddenId.value = '';
    priceBox.textContent = 'Custom Quote';
    submit.disabled = false;
    submit.textContent = 'REQUEST A QUOTE';
    submit.type = 'button';
    return;
  }

  submit.type = 'submit';
  submit.textContent = 'Continue to Live Availability';

  const product = productData[serviceKey];
  renderOptions(product);
};

  serviceSelect.addEventListener('change', loadService);
  submit.addEventListener('click', (event) => {
  const serviceKey = serviceSelect.value;

if (serviceKey === 'large' || serviceKey === 'airbnb' || serviceKey === 'commercial') {
    event.preventDefault();

    const quoteSection = document.querySelector('#contact');

    if (quoteSection) {
      quoteSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }
});

  loadService();
});
});

const quoteServiceSelect = document.querySelector('select[name="contact[service]"]');
const largeHomeFields = document.querySelector('.large-home-quote-fields');
const airbnbFields = document.querySelector('.airbnb-quote-fields');
const commercialFields = document.querySelector('.commercial-quote-fields');
const standardQuoteFields = document.querySelector('.standard-quote-fields');
const otherQuoteFields = document.querySelector('.other-quote-fields');

if (quoteServiceSelect) {
  const updateQuoteFields = () => {
    const service = quoteServiceSelect.value;
   if (largeHomeFields) {
  largeHomeFields.style.display = service === 'large' ? '' : 'none';
}

    if (airbnbFields) {
      airbnbFields.style.display = service === 'airbnb' ? '' : 'none';
    }

    if (commercialFields) {
      commercialFields.style.display = service === 'commercial' ? '' : 'none';
    }
    if (standardQuoteFields) {
  standardQuoteFields.style.display = service === 'other' ? 'none' : '';

  standardQuoteFields.querySelectorAll('[required]').forEach(field => {
    field.required = service !== 'other';
  });
}

if (otherQuoteFields) {
  otherQuoteFields.style.display = service === 'other' ? '' : 'none';
}
  };

  quoteServiceSelect.addEventListener('change', updateQuoteFields);
  updateQuoteFields();
}